import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableOpenTableSignupsComponent from '../components/TableOpenTableSignupsComponent';
import { getOpenTable } from '../utils/openTablesApi';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

const pad = (n) => String(n).padStart(2, '0');
const fmtYMD = (ymd) => {
    if (!ymd) return '—';
    const [y, m, d] = String(ymd).slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
};

// Inscripciones de una mesa abierta (FR-009, FR-051, FR-055). Molde: EventAdmissionsPage,
// con el id por parámetro de ruta (/openTableSignups/:id).
class OpenTableSignupsPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, id: null, openTable: null };
    }

    async componentDidMount() {
        const role = await validateSession();
        const id = this.props.match.params.id;
        this.setState({ checked: true, role, id });
        this.fetchOpenTable(id);
    }

    fetchOpenTable = async (id) => {
        try {
            const data = await getOpenTable(id);
            this.setState({ openTable: (data && data.openTable) || null });
        } catch (error) {
            console.error('No se pudo cargar la mesa abierta:', error);
            alert(error.message || 'Error de conexión');
        }
    }

    subtitle = () => {
        const openTable = this.state.openTable;
        if (!openTable) return 'Inscripciones';
        const partes = [`${fmtYMD(openTable.date)} ${pad(openTable.startHour)}:00`];
        if (openTable.tableLabel) partes.push(openTable.tableLabel);
        if (openTable.gameName) partes.push(openTable.gameName);
        if (openTable.hostName) partes.push(`abierta por ${openTable.hostName}`);
        return `Inscripciones — ${partes.join(' · ')}`;
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        const openTable = this.state.openTable;
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={45} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="flex-grow-1 mr-3">
                                    <HeaderComponent title="Mesas abiertas" subtitle={this.subtitle()} />
                                </div>
                                <button type="button" className="btn btn-white text-nowrap" onClick={() => navigateTo(`/editOpenTable/${this.state.id}`)}>
                                    Editar mesa
                                </button>
                            </div>
                            {openTable && (
                                <p className="text-muted mb-2">
                                    Anotados confirmados: <b>{openTable.confirmed}</b> de <b>{openTable.cupo}</b> lugares
                                    {Number(openTable.taken) > Number(openTable.confirmed) && (
                                        <span> (+{Number(openTable.taken) - Number(openTable.confirmed)} pendientes de pago)</span>
                                    )}
                                </p>
                            )}
                            {this.state.id && (
                                <TableOpenTableSignupsComponent
                                    openTableId={this.state.id}
                                    chargeMode={openTable ? openTable.chargeMode : null}
                                    unitPrice={openTable ? openTable.price : null}
                                    onChanged={() => this.fetchOpenTable(this.state.id)}
                                />
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default OpenTableSignupsPage;
